

// DOM ready
document.addEventListener("DOMContentLoaded", function() {
    // set scrollbar width CSS property, use like this in CSS: var(--scrollbar-width)
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");








    let $body = $("body");
    // Add visible state for custom select-list of filter selection
    $('body').on('click', '.pseudo-select', function(e) {

        e.stopPropagation();

        if ($body.hasClass("select-opened")) {
            $(".select-list", this).hide();
            $(this).removeClass("opened");
            $("body").removeClass("select-opened");
            $('main').css('overflow', 'hidden');
        } else {
            $(".select-list", this).show();
            $(this).addClass("opened");
            $("body").addClass("select-opened");
            $('main').css('overflow', 'visible');
        }
    });

    // Close custom select list of dropdown, when an option is clicked
    $('body').on('click', '.pseudo-select .select-list .option', function(e) {
        e.stopPropagation();
    });

    // Add visible state for custom select-list of dropdown
    $body.on('click', '.custom-dropdown, .custom-dropdown-small', function(e) {
        e.stopPropagation();
        if ($body.hasClass("dropdown-opened")) {
            $(".select-list", this).hide();
            $(this).removeClass("opened");
            $('main').css('overflow', 'hidden');
            $body.removeClass("dropdown-opened");
        } else {
            $(".select-list", this).show();
            $(this).addClass("opened");
            $('main').css('overflow', 'visible');
            $body.addClass("dropdown-opened");
        }
    });

    // Close custom select list of dropdown, when body is clicked
    $body.on('click', function() {
        // Close custom select list of dropdown, when body is clicked
        if ($(this).hasClass("dropdown-opened")) {
            $(this).find(".custom-dropdown.opened .select-list, .custom-dropdown-small.opened .select-list").hide();
            $(this).find(".custom-dropdown.opened, .custom-dropdown-small.opened").removeClass("opened");
            $body.removeClass("dropdown-opened");
            $('main').css('overflow', 'hidden');
        } else if ($(this).hasClass("select-opened")) {
            $(this).find(".pseudo-select.opened .select-list").hide();
            $(this).find(".pseudo-select.opened").removeClass("opened");
            $body.removeClass("select-opened");
            $('main').css('overflow', 'hidden');
        }
    });

    $body.on('click', '.custom-dropdown .select-list .option, .custom-dropdown-small .select-list .option', function(e) {
        // Change value of select-field and close custom select list of dropdown, when an option is clicked
        e.stopPropagation();
        let text = $(this).text();
        let value = $(this).data('val');
        let current = $(this).parent().siblings(".current");
        let select = $(this).parent().siblings(".default-select");
        $body.find(".custom-dropdown.opened .select-list, .custom-dropdown-small.opened .select-list").hide();
        $body.find(".custom-dropdown.opened, .custom-dropdown-small.opened").removeClass("opened");
        $body.removeClass("dropdown-opened");
        $('main').css('overflow', 'hidden');
        current.html(text);
        select.val(value);
        select.change();
        if (typeof (select.data('url')) !== "undefined") {
            if (value !== '') {
                window.location.href = select.data('url') + '?sec=' + value;
            } else {
                window.location.href = select.data('url');
            }
        } else {
            if (select.attr("name") === 'teacher_id') {
                //Update href of 'teacher info' link
                if ($body.find(".teacher a.info")) {
                    let href = $body.find(".teacher a.info").data('href');
                    href += value;
                    if (href.indexOf("?") === -1) {
                        text = text.replace(" ", "-");
                        text = text.replace("/", "-");
                        href += '.' + text + '.html'
                    }
                    $body.find(".teacher a.info").attr("href", href);
                }
            }
        }
    });



    // Toggle mobile filtermenu
    let $mobileFilterTrigger = $('[data-trigger="mobile-filter"]');
    let $filters = $('[data-type="mobile-filters"]');
    if ($filters != null) {
        $mobileFilterTrigger.on("click", function() {
            $filters.stop(true, true).slideToggle();
        });
    }


    (function fontsizeEnlarger() {
        // Toggle larger font-size
        let fontSizeChangeTriggers = document.querySelectorAll('[data-trigger-font-size]');
        let _body = document.body;
        let bodyFontsizeClasses;
        Array.prototype.forEach.call(fontSizeChangeTriggers, function(e) {
            e.addEventListener('click', function() {
                // remove all 'active' classes and set the active class for the clicked item
                fontSizeChangeTriggers.forEach(el => el.classList.remove('active'));
                e.classList.add('active');
                // remove all font-size classes from the body and set the font-size class of the clicked item
                bodyFontsizeClasses = _body.className.split(" ").filter(c => c.startsWith("font-size"));
                if (typeof (bodyFontsizeClasses[0]) !== "undefined") {
                    _body.classList.remove(bodyFontsizeClasses[0]);
                }
                if (e.dataset.triggerFontSize != null) {
                    _body.classList.add(e.dataset.triggerFontSize);
                    docCookies.setItem('font-size-v2',e.dataset.triggerFontSize, Infinity, "/");
                }
            });
        });
        // set a cookie so visitor doesn't have to click this each pageload
        if (docCookies.getItem('font-size-v2')) {
            _body.classList.add(docCookies.getItem('font-size-v2'));
            // toggle active class
            fontSizeChangeTriggers.forEach(el => (el.dataset.triggerFontSize === docCookies.getItem('font-size-v2') ? el.classList.add("active") : el.classList.remove("active")));
        }
    })();

    (function vrijdag() {
        const body = document.body;
        const openHeaderSearch = document.querySelector('.js-open-search')
        const closeHeaderSearch = document.querySelector('.js-close-search')
        const headerSearchFormContainer = document.querySelector('.js-searchFormContainer')
        const headerSearchForm = document.querySelector('.js-searchForm')
        if (body.classList.contains('theme-vrijdag')) {
            if (headerSearchForm != null) {
                openHeaderSearch.addEventListener('click', () => {
                    _toggleForm()
                })
                closeHeaderSearch.addEventListener('click', () => {
                    _toggleForm()
                })
                body.addEventListener('click', e => {
                    if (!headerSearchFormContainer.contains(e.target)) {
                        _toggleForm('off')
                    }
                })
            }
            const navbarCollapse = document.querySelector('.navbar-collapse')
            const header = document.querySelector('header')
            if (navbarCollapse != null && header != null) {
                // with bootstrap 4 we can't use vanilla js navbarCollapse.addEventListener() but need jQuery
                $(navbarCollapse).on('show.bs.collapse', () => {
                    header.classList.add('-fixed')
                })
                $(navbarCollapse).on('hide.bs.collapse', () => {
                    header.classList.remove('-fixed')
                })
            }

        }
        function _toggleForm (state = 'toggle') {
            if (state === 'toggle') {
                headerSearchForm.classList.toggle('-active')
                openHeaderSearch.setAttribute('aria-expanded', openHeaderSearch.getAttribute('aria-expanded') === 'true' ? 'false' : 'true')
            }
            if (state === 'off') {
                headerSearchForm.classList.remove('-active')
                openHeaderSearch.setAttribute('aria-expanded', 'false')
            }
            if (state === 'on') {
                headerSearchForm.classList.add('-active')
                openHeaderSearch.setAttribute('aria-expanded', 'true')
            }

        }

    })();

    (function eci() {
        const body = document.body;
        const toggleHeaderSearch = document.querySelectorAll('.js-toggle-search')
        const headerSearchForm = document.querySelector('.js-searchForm')
        if (body.classList.contains('theme-ecicultuurfabriek')) {
            // sticky header
            // eslint-disable-next-line no-unused-vars
            const sticky = new hcSticky('.js--sticky-navbar', {
                stickTo: 'body'
            });
            if (headerSearchForm != null) {
                [...toggleHeaderSearch].forEach(searchToggleElem => {
                    searchToggleElem.addEventListener('click', () => {
                        headerSearchForm.classList.toggle('-active');
                        [...toggleHeaderSearch].forEach(_searchToggleElem => _searchToggleElem.classList.toggle('-active'))
                    })
                });

            }
        }
    })();

    (function lindenberg() {
        const body = document.body;
        if (body.classList.contains('theme-lindenberg')) {
            // sticky header
            // eslint-disable-next-line no-unused-vars
            const sticky = new hcSticky('.js--sticky-navbar', {
                stickTo: 'body',
                responsive: {
                    576: {
                        disable: true
                    }
                }
            });
            const toTop = document.querySelector('.js-to-top');
            if (toTop != null) {
                toTop.addEventListener('click', e => {
                    e.preventDefault();
                    window.scroll({top: 0, left: 0, behavior: 'smooth'});
                })
            }
        }
    })();

    (function boz() {
        const body = document.body;
        if (body.classList.contains('theme-boz')) {
            // sticky header
            // eslint-disable-next-line no-unused-vars
            const sticky = new hcSticky('.js--sticky-navbar', {
                stickTo: 'body',
                // responsive: {
                //     576: {
                //         disable: true
                //     }
                // }
            });
        }
    })();

    (function kclouis() {
        const body = document.body;
        if (body.classList.contains('theme-kclouis')) {

            const navbarCollapse = document.querySelector('.navbar-collapse')
            const header = document.querySelector('header')
            if (navbarCollapse != null && header != null) {
                // with bootstrap 4 we can't use vanilla js navbarCollapse.addEventListener() but need jQuery
                // $(navbarCollapse).on('show.bs.collapsing', () => {
                //     header.classList.add('-collapsing')
                // });
                $(navbarCollapse).on('show.bs.collapse', () => {
                    header.classList.add('-collapsing')
                    // header.classList.add('-fixed')
                })

                $(navbarCollapse).on('shown.bs.collapse', () => {
                    header.classList.add('-fixed')
                })
                $(navbarCollapse).on('hide.bs.collapse', () => {
                    header.classList.remove('-fixed')
                })
                $(navbarCollapse).on('hidden.bs.collapse', () => {
                    header.classList.remove('-collapsing')
                })
            }

            // sticky header
            // eslint-disable-next-line no-unused-vars
            const sticky = new hcSticky('.js--sticky-navbar', {
                stickTo: 'body',
                // responsive: {
                //     576: {
                //         disable: true
                //     }
                // }
            });
        }
    })();



});


window.addEventListener("load", () => {
    (function vrijdag() {
        const body = document.body;
        const rootElement = document.documentElement;

        if (body.classList.contains('theme-vrijdag')) {
            // set header height to css var
            const header = document.querySelector('.container-logo-social-wrap')
            if (header != null) {
                respondToVisibility(header, visible => {
                    if (visible) {
                        rootElement.style.setProperty('--header-height', (header.getBoundingClientRect()?.height || 0) + 'px');
                    }
                })
                respondToResize(header, borderBoxSize => {
                    if (borderBoxSize && borderBoxSize[0]?.blockSize != null) {
                        rootElement.style.setProperty('--header-height', borderBoxSize[0].blockSize + 'px');
                    }
                })
            }
        }


    })();
})



/**********************
 ** Helper functions **
 *********************/
const debounce = (f, delay) => {
    let timer = 0;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => f.apply(this, args), delay);
    }
}

const respondToVisibility = function(element, callback) {
    var options = {
        root: null // set to viewport so fixed positioned elements are also in scope
        // root: document.documentElement
    };
    // eslint-disable-next-line no-unused-vars
    var observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            callback(entry.intersectionRatio > 0);
        });
    }, options);
    observer.observe(element);
};

const respondToResize = function(element, callback, debounceTime) {
    const _debounceTime = debounceTime || 0;
    const observer = new ResizeObserver(debounce((entries) => {
        entries.forEach(entry => {
            if (entry.borderBoxSize) {
                callback(entry.borderBoxSize)
            }
        })
    }, _debounceTime));
    observer.observe(element);
}
